import {createContext} from 'react'

/**
 * Provides the authoritative page-level slot position to any CMS component
 * rendered inside SlotContent. Components and hooks read from this rather
 * than relying on props being drilled through wrapper components.
 *
 * Kept in a dedicated file to avoid a circular dependency between:
 *   Slot.tsx → CMS components → promotion-tracking.js → Slot.tsx
 */
export const CurrentSlotPositionContext = createContext<number | undefined>(undefined)
